
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whole-home-backup-power-solution",
      function () {
        return require("private-next-pages/whole-home-backup-power-solution/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whole-home-backup-power-solution"])
      });
    }
  